import { render, staticRenderFns } from "./header-bar.vue?vue&type=template&id=8b7f3fac"
import script from "./header-bar.vue?vue&type=script&lang=js"
export * from "./header-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports